module.exports = __webpack_public_path__ + "img/hr-green-pita-07.6e1214a7.png";